var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCarpentry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.77 14.03l3.785 3.785-10.409 10.408-3.785-3.785L41.77 14.03zm-7.57-3.785L30.415 6.46l-5.677 5.677 3.785 3.785 5.677-5.677zm-6.623 6.623l-3.785-3.784L9.599 27.276l3.784 3.785 14.194-14.193zm21.762 8.516l3.785 3.785L41.77 40.524l-3.785-3.785L49.34 25.384zM40.825 41.47l-3.785-3.785-8.516 8.516 3.785 3.785 8.516-8.516zm-27.44-.947l-3.786-3.785L20.007 26.33l3.784 3.785-10.408 10.408zm7.569-15.139l3.785 3.785 11.354-11.355-3.785-3.784-11.354 11.354zM34.2 29.169l-3.785-3.785L19.061 36.74l3.785 3.785L34.2 29.168zm-2.839 12.3l-8.516 8.516-3.784-3.784 8.515-8.516 3.785 3.785zm-3.785-3.784l3.785 3.785 14.193-14.194-3.785-3.784-14.192 14.193z",
    fill: "#E3B05F"
  })));
}

export default SvgCarpentry;